"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEventType = void 0;
var EEventType;
(function (EEventType) {
    EEventType["ProductUpdate"] = "ITEM_UPDATE";
    EEventType["VariantStockUpdate"] = "VARIANT_STOCK_UPDATE";
    EEventType["OfferStockUpdate"] = "OFFER_STOCK_UPDATE";
})(EEventType || (exports.EEventType = EEventType = {}));
//# sourceMappingURL=event-log.js.map